import Flip from './flip'
import FlipInX from './flip-in-x'
import FlipInY from './flip-in-y'
import FlipOutX from './flip-out-x'
import FlipOutY from './flip-out-y'

export default {
  Flip,
  FlipInX,
  FlipInY,
  FlipOutX,
  FlipOutY
}



// WEBPACK FOOTER //
// ./src/animates/animated-vue/transitions/flippers/index.js